<template>
  <div class="text-base">
    <span
      class="z-10 h-full leading-snug font-normal absolute text-center text-gray-400 absolute bg-transparent rounded items-center justify-center w-8 pl-3 py-3"
    >
      <i class="fas fa-search" />
    </span>
    <input
      icon="fa fa-user"
      :class="inputClasses"
      :value="value"
      :placeholder="placeholder"
      :type="type"
      :min="min"
      :max="max"
      :inputmode="inputMode"
      :required="required"
      :disabled="disabled"
      @input="$emit('input', $event.target.value)"
    />
    <div v-if="validator && validator.$error">
      <ul
        v-for="(value, key) in validationsMessage"
        :key="key"
        class="input-error"
      >
        <li v-if="!validator[key]">
          {{ value }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: [String, Number],
    error: Boolean,
    classCustom: String,
    type: {
      type: String,
      default: "text",
    },
    placeholder: String,
    inputMode: String,
    min: {
      type: Number,
      default: null,
    },
    max: {
      type: Number,
      default: null,
    },
    required: { default: false },
    disabled: {
      type: Boolean,
      default: false,
    },
    validationsMessage: {
      type: Object,
      default: null,
    },
    validator: {
      type: Object,
      default: null,
    },
  },
  computed: {
    inputClasses() {
      return [
        this.classCustom
          ? this.classCustom
          : "w-full bg-white default-input input-size-default text-gray-700 border-l-4 rounded px-8 leading-tight focus:outline-none transition focus:shadow focus:border-pink-500",
        this.error ? "fail-error" : "border",
        this.disabled ? "bg-gray-200" : "",
      ];
    },
  },
};
</script>
